import instance from 'utils/axios.utils';

const payout = {
  createPayout: (data) => {
    let promise = new Promise((resolve, reject) => {
      let url = 'payout/create_payout';
      instance()
        .post(url, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
    return promise;
  },
  getManyPayout: (data?) => {
    let promise = new Promise((resolve, reject) => {
      let url = 'payout/get_many_payout';
      instance()
        .post(url, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          if (error.response) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
    return promise;
  },
};

export default payout;
